import * as React from 'react';
const SvgVolumeWave2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M15.465 8.535a.43.43 0 0 0-.013.578A4.48 4.48 0 0 1 16.5 12a4.48 4.48 0 0 1-1.048 2.887.43.43 0 0 0 .013.578l.495.495a.38.38 0 0 0 .556-.01A5.98 5.98 0 0 0 18 12c0-1.513-.56-2.895-1.484-3.95a.38.38 0 0 0-.556-.01z"
    />
    <path
      fill="currentColor"
      d="M17.579 17.013a.417.417 0 0 0 .007.573l.495.495c.156.156.41.157.56-.006A8.97 8.97 0 0 0 21 12a8.97 8.97 0 0 0-2.36-6.075.387.387 0 0 0-.559-.006l-.495.495a.417.417 0 0 0-.008.573A7.47 7.47 0 0 1 19.5 12a7.47 7.47 0 0 1-1.922 5.013M14 5.49c0-.433-.513-.65-.835-.36L9 9H6.18a.75.75 0 0 0-.707.464A7 7 0 0 0 5 12c0 .894.168 1.75.473 2.536A.75.75 0 0 0 6.18 15H9l4.166 3.87A.5.5 0 0 0 14 18.5z"
    />
  </svg>
);
export default SvgVolumeWave2;
